var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import { TRIP_TYPE_ONE_WAY, SESSION_VAR_KEY_LANGUAGE, TRIP_TYPE_ONE_WAY_CODE, SESSION_VAR_KEY_MARKET } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
var INDRABusTripModalComponent = /** @class */ (function (_super) {
    __extends(INDRABusTripModalComponent, _super);
    function INDRABusTripModalComponent(store, modalService, fb, ibeAdminService, indraBookingService) {
        var _this = _super.call(this, modalService) || this;
        _this.store = store;
        _this.modalService = modalService;
        _this.fb = fb;
        _this.ibeAdminService = ibeAdminService;
        _this.indraBookingService = indraBookingService;
        _this.optionsHopOff = [
        /* { value: 'PONTEVEDRA', label: 'Pontevedra (Estação de Autocarros em frente à cafetaria)' },
        { value: 'PORRINO', label: 'Porrino (Eroski Center - Sanguineda)' },
        { value: 'VIGO', label: 'Vigo (Estação Autocarros Cais 12/13)' } */
        ];
        _this.optionsHopOn = [
        /* { value: 'VIGO', label: 'Vigo (Estação Autocarros Cais 12/13)' },
        { value: 'PORRINO', label: 'Porrino (Eroski Center - Sanguineda)' },
        { value: 'PONTEVEDRA', label: 'Pontevedra (Estação de Autocarros em frente à cafetaria)' } */
        ];
        _this.timeToThink$ = _this.store.select(fromStore.getSelectedBookedTripTimeToThink);
        _this.timeToThink = false;
        _this.triedToSubmit = false;
        _this.isAlive = true;
        _this.booking_trip$ = _this.store.select(fromStore.getSelectedBookedTrip);
        _this.bookingSteps$ = _this.store.select(fromStore.getSelectedBookingSteps);
        _this.oneWay = TRIP_TYPE_ONE_WAY;
        _this.allSingleStop = false;
        _this.singleBusStopDetails = [];
        _this.TYPE = 'dialog';
        _this.timeToThink$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.timeToThink = value;
        });
        _this.bookingSteps$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.bookingSteps = value;
            }
        });
        _this.booking_trip$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.booking_trip = value;
        });
        return _this;
    }
    INDRABusTripModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.data && this.data.length && this.data[0].stops) {
            this.stops = this.data[0].stops;
        }
        if (this.data && this.data.length && this.data[0].locations) {
            this.locations = this.data[0].locations;
        }
        if (this.data && this.data.length && this.data[0].busStopLocation) {
            this.busStopLocation = this.data[0].busStopLocation;
        }
        this.language = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE);
        this.market = sessionStorage.getItem(SESSION_VAR_KEY_MARKET);
        this.stops = this.stops.sort(function (currentStop, nextStop) { return currentStop.index - nextStop.index; });
        for (var i in this.stops) {
            var busDetails = this.stops[i].busStops;
            var hopOffDetails = [];
            var isMultipleStops = false;
            for (var x in busDetails) {
                /* Temporary Logic for labels. Remove replace when ibeAdminKey is in the correct format */
                var label = 'busStops.label.' + busDetails[x].ibeAdminKey.replace('KEY_', '').replace('_', '');
                var stop_1 = {
                    value: busDetails[x].value,
                    label: this.INDRA_getTranslation(label),
                    hop: busDetails[x].hop
                };
                hopOffDetails.push(stop_1);
                if (busDetails[x].hop && busDetails[x].hop.toLowerCase() === 'all') {
                    isMultipleStops = true;
                }
            }
            //if (hopOffDetails.length == 1) {
            if (!isMultipleStops) {
                this.singleBusStopDetails.push(hopOffDetails);
            }
            this.optionsHopOff.push(hopOffDetails);
        }
        if (this.singleBusStopDetails.length == this.optionsHopOff.length) {
            this.allSingleStop = true;
        }
        this.form = this.fb.group({
            stops: this.fb.array([]),
        });
        this.stops.forEach(function (item, idx) {
            _this.form.get('stops').push(_this.createStops(idx));
        });
    };
    INDRABusTripModalComponent.prototype.createStops = function (hopOff) {
        if (hopOff === void 0) { hopOff = ''; }
        return this.fb.group({
            hopOff: new FormControl(null, Validators.required),
        });
    };
    INDRABusTripModalComponent.prototype.closeModal = function () {
        this.modalService.close();
        this.isAlive = false;
    };
    INDRABusTripModalComponent.prototype.cancel = function () {
        this.closeModal();
    };
    INDRABusTripModalComponent.prototype.confirm = function () {
        if (this.allSingleStop) {
            var busStops = [];
            for (var i in this.singleBusStopDetails) {
                busStops.push(Object.assign({}, {
                    hopOff: this.singleBusStopDetails[i].find(function (stop) { return stop.hop && stop.hop.toLowerCase() === 'off'; }).value
                }));
            }
            var returnValue = Object.assign({}, { stops: busStops });
            this.data[0].handleClose(returnValue);
            this.modalService.close();
        }
        else {
            this.triedToSubmit = true;
            if (this.form.valid) {
                this.data[0].handleClose(this.form.value);
                this.modalService.close();
            }
        }
    };
    INDRABusTripModalComponent.prototype.INDRA_getCity = function (index) {
        return this.locations[this.stops[index].params.origin].city + " - " + this.locations[this.stops[index].params.destination].city;
    };
    INDRABusTripModalComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRABusTripModalComponent.prototype.INDRA_getPlaceholder = function (index) {
        if (this.booking_trip.booking_type == TRIP_TYPE_ONE_WAY_CODE) {
            return this.INDRA_getTranslation('modals.busTrip.text.selectHopOff');
        }
        else if ((index + 1) != this.stops.length) {
            return this.INDRA_getTranslation('modals.busTrip.text.selectHopOff');
        }
        return this.INDRA_getTranslation('modals.busTrip.text.selectHopOn');
    };
    INDRABusTripModalComponent.prototype.INDRA_getBusScheduleURL = function () {
        return "https://www.flytap.com/" + this.language + "-" + this.market + "/other-bookings/transport-galicia-porto";
    };
    INDRABusTripModalComponent.prototype.INDRA_isLastStop = function (index) {
        return (index + 1) == this.singleBusStopDetails.length;
    };
    INDRABusTripModalComponent.prototype.INDRA_displayHopLabel = function (stops, hopType) {
        if (stops && stops.length) {
            var stop_2 = stops.find(function (stop) { return stop.hop && stop.hop.toLowerCase() === hopType; });
            return stop_2 ? stop_2.label : '';
        }
        return '';
    };
    return INDRABusTripModalComponent;
}(AbstractModalContentComponent));
export { INDRABusTripModalComponent };
